import { useEffect, useRef } from 'react';

function TallyForm({
    isUsingDarkMode
}) {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (window.Tally) {
      window.Tally.loadEmbeds();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.onload = () => {
      if (window.Tally) {
        window.Tally.loadEmbeds();
      }
    };
    script.onerror = () => {
      if (iframeRef.current && !iframeRef.current.src) {
        iframeRef.current.src = iframeRef.current.dataset.tallySrc;
      }
    };

    document.body.appendChild(script);
  }, []);


  return isUsingDarkMode ? (
    <iframe
      ref={iframeRef}
      data-tally-src="https://tally.so/embed/woXd11?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1&darkMode=1"
      loading="lazy"
      width="100%"
      height="579"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Get your free map"
    />
  ) : (
    <iframe
      ref={iframeRef}
      data-tally-src="https://tally.so/embed/wdBjXy?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1&darkMode=1"
      loading="lazy"
      width="100%"
      height="579"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Get your free map"
    />
  );
}

export default TallyForm;